import React, { FC } from 'react';
import SvgIcon, {SvgIconProps} from "@mui/material/SvgIcon";

const ArrowRight: FC<SvgIconProps> = (props) => (
	<SvgIcon { ...props } viewBox="0 0 24 24">
		<path d="M15 5L13.59 6.41L18.17 11L2 11L2 13L18.17 13L13.58 17.59L15 19L22 12L15 5Z" />
	</SvgIcon>
)

export default ArrowRight;
